import { render } from "./Vuetable.vue?vue&type=template&id=6a3cdc50&scoped=true"
import script from "./Vuetable.vue?vue&type=script&lang=js"
export * from "./Vuetable.vue?vue&type=script&lang=js"

import "./Vuetable.vue?vue&type=style&index=0&id=6a3cdc50&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a3cdc50"]])

export default __exports__